<template>
  <material-card
    :title="title"
    data-testId="material-card-title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            text-xs-right>
            <v-btn
              data-testId="btn-info"
              small
              class="mx-0 my-0"
              dark
              fab
              color="dover-blue"
              @click="showInfoDialog(true)">
              <v-icon dark>
                mdi-information
              </v-icon>
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="fairbanks.server"
              :rules="rules.required"
              :label="`${ $t('Server') }`"
              data-testId="text-field-Server"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="fairbanks.folder"
              :label="`${ $t('Folder') }`"
              data-testId="text-field-Folder"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="fairbanks.user"
              :rules="rules.required"
              :label="`${ $t('User') }`"
              data-testId="text-field-User"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <MaglinkComponentPassword
              :label="`${ $t('Password') }`"
              :initial-value="fairbanks.password"
              :rules="rules.required"
              data-testId="MaglinkComponentPassword-Password"
              comp-key="login"
              @onPasswordChange="onPasswordChange" />
          </v-flex>
          <v-flex
            xs12
            md6 >
            <v-text-field
              v-model.trim="fairbanks.id"
              :rules="rules.required"
              :counter="6"
              :label="`${ $t('Id').toUpperCase() }`"
              data-testId="text-field-Id"
              mask="######"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.number="fairbanks.port"
              :rules="rules.required.concat(rules.port)"
              :counter="5"
              :label="`${ $t('Port') }`"
              data-testId="text-field-Port"
              mask="#####"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.number="fairbanks.uploadInterval"
              :rules="rules.required.concat(rules.interval)"
              :counter="4"
              :label="`${ $t('Upload interval (min)') }`"
              data-testId="text-field-Upload-interval"
              mask="####"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-switch
              v-model="fairbanks.enableSSL"
              :label="`${ $t('Enable SFTP') }`"
              data-testId="switch-Enable-SFTP"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-left>
            <span
              data-testId="span-Transfer-mode"
              class="caption grey--text font-weight-light">
              {{ $t('Transfer mode') }}
            </span>
            <hr>
            <v-radio-group
              v-model="fairbanks.transferMode"
              :row="true"
              data-testId="radio-group">
              <v-radio
                v-for="(transferMode, index) in transferModes"
                :key="index"
                :label="`${ $t(transferMode.desc) }`"
                :value="transferMode.code"
                data-testId="radio-transferMode" />
            </v-radio-group>
          </v-flex>
          <v-flex
            xs12
            md12
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
          <v-dialog
            v-model="infoDialog"
            data-testId="dialog"
            persistent
            width="600px"
            @keydown.esc="infoDialog = false">
            <v-card>
              <v-card-title
                data-testId="card-title-File-format-information"
                class="headline grey lighten-2"
                primary-title>
                {{ $t('File format information') }}
              </v-card-title>
              <v-card-title
                class="title font-weight-bold" >
                {{ $t('Inventories') }}
              </v-card-title>
              <v-card-text>
                <div>{{ $t('Filename') + ': ' }} stockLevels_YYYY-MM-DD_hhmmss.csv</div>
              </v-card-text>
              <v-card-title
                class="title font-weight-bold" >
                {{ $t('Transactions') }}</v-card-title>
              <v-card-text>
                <div>{{ $t('Filename') + ': ' }} transactions_YYYY-MM-DD_hhmmss.csv</div>
              </v-card-text>
              <v-card-title
                class="title font-weight-bold" >
                {{ $t('Deliveries') }}</v-card-title>
              <v-card-text>
                <div>{{ $t('Filename') + ': ' }} deliveries_YYYY-MM-DD_hhmmss.csv</div>
              </v-card-text>
              <v-card-title
                class="title font-weight-bold" >
                {{ $t('Alarms') }}</v-card-title>
              <v-card-text>
                <div>{{ $t('Filename') + ': ' }} alarms_YYYY-MM-DD_hhmmss.csv</div>
              </v-card-text>
              <v-card-text>
                <div>{{ $t('Tank') }}</div>
                <div><v-chip>PG_00</v-chip>{{ $t('Tank OK Status') }}</div>
                <div><v-chip>PG_01</v-chip>{{ $t('No link to the probe') }}</div>
                <div><v-chip>PG_02</v-chip>{{ $t('Product High') }}</div>
                <div><v-chip>PG_03</v-chip>{{ $t('Product Low') }}</div>
                <div><v-chip>PG_05</v-chip>{{ $t('Probe reading error') }}</div>
                <div><v-chip>PG_06</v-chip>{{ $t('Product Very High') }}</div>
                <div><v-chip>PG_07</v-chip>{{ $t('Product Very Low') }}</div>
                <div><v-chip>PG_10</v-chip>{{ $t('Water detected') }}</div>
                <div><v-chip>PG_11-PG19</v-chip>{{ $t('Water detected') + ' + ' + $t('other alarm') }}</div>
                <div><v-chip>PG_61</v-chip>{{ $t('Sudden Loss') }}</div>
                <div>{{ $t('Sensor') }}</div>
                <div><v-chip>PG_20</v-chip>{{ $t('Sensor OK Status') }}</div>
                <div><v-chip>PG_21</v-chip>{{ $t('No link to the sensor') }}</div>
                <div><v-chip>PG_22</v-chip>{{ $t('Product High') }}</div>
                <div><v-chip>PG_23</v-chip>{{ $t('Water detected') }}</div>
                <div><v-chip>PG_24</v-chip>{{ $t('Water detected') + ' + ' + $t('Product High') }}</div>
                <div><v-chip>PG_25</v-chip>{{ $t('Sensor reading error') }}</div>
                <div><v-chip>PG_26</v-chip>{{ $t('Sensor activated') }}</div>
                <div><v-chip>PG_27</v-chip>{{ $t('Open') }}</div>
                <div><v-chip>PG_28</v-chip>{{ $t('Short') }}</div>
                <div><v-chip>PG_29</v-chip>{{ $t('Vapor') }}</div>
                <div><v-chip>PG_31</v-chip>{{ $t('Liquid Warning') }}</div>
                <div><v-chip>PG_32</v-chip>{{ $t('Liquid High') }}</div>
                <div>{{ $t('Line Leak Detector') }}</div>
                <div><v-chip>PG_40</v-chip>{{ $t('LLD OK Status') }}</div>
                <div><v-chip>PG_41</v-chip>{{ $t('No link to the pressure sensor') }}</div>
                <div><v-chip>PG_42</v-chip>{{ $t('No link to the STP controller') }}</div>
                <div><v-chip>PG_43</v-chip>{{ $t('STP Error') }}</div>
                <div><v-chip>PG_44</v-chip>{{ $t('Line leak detected') }}</div>
                <div><v-chip>PG_45</v-chip>{{ $t('No leak test') }}</div>
                <div><v-chip>PG_46</v-chip>{{ $t('No annual leak test') }}</div>
                <div><v-chip>PG_47</v-chip>{{ $t('Pressure sensor open') }}</div>
                <div><v-chip>PG_48</v-chip>{{ $t('Pressure sensor short') }}</div>
                <div><v-chip>PG_49</v-chip>{{ $t('Low pressure in the pipeline') }}</div>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-flex
                  xs12
                  md12
                  text-xs-right>
                  <v-btn
                    data-testId="btn-Close"
                    color="secondary"
                    flat
                    @click="showInfoDialog(false)">
                    {{ $t('Close') }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      interval: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 1440) ],
      port: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 65535) ]
    },
    fairbanks: {},
    transferModes: [],
    infoDialog: false
  }),
  mounted () {
    this.Maglink.GetOptions()
      .then(response => {
        this.transferModes = response.data.transferModes
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('Fairbanks')
      .then(response => {
        this.fairbanks = { ...this.fairbanks, ...response.data }
      }).catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onPasswordChange (newPassword, compKey) {
      this.fairbanks.password = newPassword
    },
    showInfoDialog (value) {
      this.infoDialog = value
    },
    save (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        this.Maglink.SetSettings('Fairbanks', this.fairbanks)
          .then(response => (this.snack('success', response.data['done'])))
          .catch(error => (this.snack('error', error.message)))

        this.$emit('settingsSaved')
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
